import React from "react";

const SpacerWidget = (props) => {
    if(!props?.h) return null
    
    return (
        <div data-test-id="spacer-wr" className={"widget widget-spacer" + (props?.dark ? " bg-dark" : "")} style={{ height: props.h + "px" }}></div>
    )
}

export default SpacerWidget;